import React, { Component } from 'react'
import { number, func, bool } from 'prop-types'
import { createComponent } from '@ycos/fela'
import { getSize, getContainerPosition } from './utils'

class Paginator extends Component {
  shouldComponentUpdate(nextProps) {
    const pagesChanged = this.props.pages !== nextProps.pages
    const currentPageChanges = this.props.currentPage !== nextProps.currentPage
    if (pagesChanged || currentPageChanges) {
      return true
    }
    return false
  }

  render() {
    const { currentPage, pages, onPageChange, numOnDisplay, showPaginator } = this.props

    if (pages <= 1) {
      return null
    }
    const oddNumOnDisplay = numOnDisplay % 2 === 0 ? numOnDisplay - 1 : numOnDisplay
    const containerPosition = getContainerPosition(currentPage, pages, oddNumOnDisplay)

    return (
      showPaginator && (
        <Container data-automation="Paginator">
          <Centered>
            <Pages position={containerPosition}>
              {[...Array(pages).keys()].map((page) => (
                <Page
                  data-automation="page"
                  key={page}
                  current={page === currentPage - 1}
                  onClick={() => onPageChange && onPageChange(page)}
                  size={getSize(page, currentPage - 1, pages, oddNumOnDisplay)}
                />
              ))}
            </Pages>
          </Centered>
        </Container>
      )
    )
  }
}

Paginator.defaultProps = {
  numOnDisplay: 5,
  showPaginator: false
}
Paginator.propTypes = {
  pages: number.isRequired,
  currentPage: number.isRequired,
  onPageChange: func.isRequired,
  showPaginator: bool,
  numOnDisplay: number
}

const getPosition = (position) => {
  if (position === 'top') {
    return 'absolute'
  }
  return 'relative'
}

const Container = createComponent('Container', ({ theme }) => ({
  bottom: 0,
  left: 0,
  position: getPosition(theme.custom.carousel.paginatorPosition),
  width: '100%'
}))

const Centered = createComponent('Centered', ({ theme }) => ({
  margin: '0 auto',
  maxWidth: `${17 * theme.spacingMultiplier}px`,
  overflow: 'hidden',
  paddingTop: `${theme.custom.carousel.paginatorTopSpacing}px`,
  paddingBottom: `${theme.custom.carousel.paginatorBottomSpacing}px`,
  position: 'relative',
  width: `${17 * theme.spacingMultiplier}px`
}))

const Pages = createComponent('Pages', ({ position, theme }) => ({
  whiteSpace: 'nowrap',
  flexWrap: 'nowrap',
  textAlign: 'center',
  transitionProperty: 'all',
  transitionDuration: theme.custom.animations.slow,
  transitionTimingFunction: theme.custom.animations.easing,
  transform: `translateX(${position}px)`
}))

const Page = createComponent(
  'Page',
  ({ current, size, theme }) => ({
    position: 'relative',
    width: `${theme.spacingMultiplier}px`,
    height: `${theme.spacingMultiplier}px`,
    borderRadius: '50%',
    border: 0,
    cursor: 'pointer',
    background: theme.custom.carousel.paginatorColor,
    marginLeft: `${theme.spacingMultiplier}px`,
    marginRight: `${theme.spacingMultiplier}px`,
    opacity: current ? 1 : 0.4,
    padding: 0,
    transitionProperty: 'all',
    transitionDuration: theme.custom.animations.slow,
    transitionTimingFunction: theme.custom.animations.easing,
    transform: `scale(${size})`,
    display: 'inline-block',
    ':focus': {
      outline: 0
    },
    ':after': {
      position: 'absolute',
      content: '',
      top: `-${theme.spacingMultiplier}px`,
      right: `-${theme.spacingMultiplier}px`,
      left: `-${theme.spacingMultiplier}px`,
      bottom: `-${theme.spacingMultiplier}px`
    }
  }),
  'button'
)

export default Paginator
